"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const task_1 = require("./task");
const index_1 = require("./index");
class TaskList extends index_1.TopLevelNode {
    constructor(localId) {
        super();
        this.localId = localId;
        this.content = new index_1.ContentNode('taskList');
    }
    task(localId, state) {
        return this.content.add(new task_1.Task(localId, state));
    }
    toJSON() {
        return Object.assign({}, this.content.toJSON(), { attrs: {
                localId: this.localId
            } });
    }
}
exports.TaskList = TaskList;
//# sourceMappingURL=task-list.js.map